import config from '@/config';
import { HTTP, MainAppResource } from './base';

const host = config.API_URL;

export default Object.assign(MainAppResource('api/v3/events{/id}'), {
  waveform({ eventId }) {
    return HTTP.get(`${host}/api/v3/events/${eventId}/waveform`);
  }
});
